// Alert domain constants — categories, severity, type metadata.

export const ALERT_CATEGORY_META = {
  just_off:   { label: 'Short Term Breach', icon: 'notification_important', color: '#dc2626', bgLight: 'rgba(220,38,38,0.08)',  bgDark: 'rgba(220,38,38,0.18)',  border: 'rgba(220,38,38,0.28)',  desc: 'Just went out of range' },
  predictive: { label: 'Early Warning',    icon: 'schedule',               color: '#7c3aed', bgLight: 'rgba(124,58,237,0.08)', bgDark: 'rgba(124,58,237,0.18)', border: 'rgba(124,58,237,0.28)', desc: 'Forecast to breach soon' },
  ongoing:    { label: 'Sustained Breach', icon: 'running_with_errors',    color: '#d97706', bgLight: 'rgba(217,119,6,0.08)',  bgDark: 'rgba(217,119,6,0.18)',  border: 'rgba(217,119,6,0.28)',  desc: 'Off range for a while' },
  stale:      { label: 'Stale Data', icon: 'sensors_off',            color: '#0891b2', bgLight: 'rgba(8,145,178,0.08)',  bgDark: 'rgba(8,145,178,0.18)',  border: 'rgba(8,145,178,0.28)',  desc: 'No new data within expected window' },
};

export function catBg(meta, isDark) {
  return isDark ? meta.bgDark : meta.bgLight;
}

export const ALERT_CATEGORY_ORDER = ['just_off', 'ongoing', 'predictive', 'stale'];

export const SEVERITY_META = {
  critical: { label: 'Critical', color: '#dc2626', bgLight: 'rgba(220,38,38,0.10)', bgDark: 'rgba(220,38,38,0.22)', border: 'rgba(220,38,38,0.32)' },
  warning:  { label: 'Warning',  color: '#d97706', bgLight: 'rgba(217,119,6,0.10)', bgDark: 'rgba(217,119,6,0.22)', border: 'rgba(217,119,6,0.32)' },
};

export function sevBg(meta, isDark) {
  return isDark ? meta.bgDark : meta.bgLight;
}

export const ALERT_ACCENT = '#dc2626';

export const HIST_OUTCOME_META = {
  resolved:      { label: 'Resolved',      color: '#16a34a' },
  auto_resolved: { label: 'Auto-resolved', color: '#0891b2' },
  expired:       { label: 'Expired',       color: '#64748b' },
};

export const ALERT_VARTYPE_META = {
  target:       { label: 'Target',       color: '#7c3aed' },
  controllable: { label: 'Controllable', color: '#3b82f6' },
  observed:     { label: 'Observed',     color: '#0891b2' },
};
